module.exports = __webpack_public_path__ + "img/NoLogo.09aff9a2.jpg";